const getters = {
  entities(state) {
    return state.entities;
  },
};

export default getters;
